<template lang='pug'>
  router-link.merchant.component.container.actionable( :to='{ name: "merchant", params: {id: item.id} }' )
    bf-flex.stamp.component.centered( v-if='item.sample' ) 
      label {{$t("SAMPLE")}}
    base-card
      header
        .fav-btn.actionable(v-if='user.uid && user.uid != item.user_id' :class='{ fav: favored }' @click.stop.prevent='favor')
          .icon
            fav-icon
        
        .img
          img( :src='item.logo' )
        .attr
          h4.title {{ item.name }}
          p.hours 
            span {{$t("Hours")}}: {{ opening }} - {{ closing }} 
          p(v-if='item.web') 
            web-icon.icon2
            span {{ webaddr }} 
          p(v-if='item.phone')
            phone-icon.icon2
            span {{ item.phone }}
          p.desc {{ desc }}
          
          //- p.op-hrs Open {{ opening }} - {{ closing }} 
          //- p {{ item.web }} 
          //- p {{ item.phone }}
      //- footer
      //-   span.avail
      //-     span.icon
      //-       schedule-icon
      //-     span.text Check Availability
      //-   span.appt
      //-     span.icon
      //-       schedule-icon
      //-     span.text Make an Appointment
</template>

<script>
  import { db } from '@/main'
  import BaseCard from '@/components/base-card'
  import FavorableIcon from 'vue-material-design-icons/HeartOutline'
  import SocialButton from '@/components/social-button'

  export default {
    name: 'rsv-card.component',

    components: {
      BaseCard,
      FavorableIcon
    },

    data() {
      return {
        favorites: []
      }
    },

    props: {
      item: Object,
      user: { type: Object, required: true }
    },

    computed: {
      opening() {
        let d = new Date(this.item.cfg.opening)
        d.setMinutes( d.getMinutes() + new Date().getTimezoneOffset() )
        return d.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
      },

      closing() {
        let d = new Date(this.item.cfg.closing)
        d.setMinutes( d.getMinutes() + new Date().getTimezoneOffset() )
        return d.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
      },

      desc(){
        return this.item.description ? this.item.description.length>100? this.item.description.substring(0,100)+' ...':this.item.description:''
      },

      webaddr(){
        return this.item.description ? this.item.web.length>25? this.item.web.substring(0,25)+' ...':this.item.web:''
      },

      favored() {
        return !!this.favorites.filter( favorite => favorite.business_id === this.item.id ).length
      },
    },

    methods: {
      favor() {
        if ( this.favored )
          db.collection('favorites').doc(
            this.favorites.find( favorite => favorite.business_id === this.item.id ).id
          ).delete()
        else
          db.collection('favorites').doc( `${this.user.uid}->${this.item.id}` ).set({
            business_id: this.item.id,
            account_id: this.user.uid
          })
      },

      favor2() {
        let id = `${this.user.email}->${this.item.id}`
        db.collection( 'favorites' ).doc( id ).set({ 
          account_id: this.user.uid, 
          uid: this.user.uid, 
          business_id: this.item.id 
        })
      }
    },

    mounted() {
      if ( this.user.uid ) {
        this.$binding( 'favorites', db.collection('favorites').where( 'account_id', '==', this.user.uid) )
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .fav-btn
    position absolute 
    right 12px
    top 8px
    text-align center
    .icon
      font-size 2.21em
    &.fav .icon
      color red
  .favor
    position absolute
    right 12px
    top 8px
    font-size 1.65em
    color rgb( 160 160 160 )
  
  .hours
    background orange 
    color white
    padding 5px
    border-radius 5px
    
  .icon2
    font-size 0.5em
    color gray
    vertical-align middle
    margin-right 5px

  .merchant 
    display block

  .merchant .base-card
    height 100%
    display flex
    flex-direction column
    overflow hidden
    box-shadow 0 1px 2px #8d949e
    header
      display flex
      align-items flex-start
      padding 16px
      padding-left 0
    .img
      padding 0 16px
      img
        height 64px
        width 64px
        object-fit cover
        border-radius 7px
    p
      margin-top 8px
    
    footer
      border-top 1px solid rgba( 0 0 0 .1 )
      margin-top auto
      > span
        padding 16px 0
        display inline-block
        width 50%
        text-align center
        box-sizing border-box
        &:first-child
          border-right 1px solid rgba( 0 0 0 .1 )
        .icon
          margin-right 12px
      @media( max-width: 480px )
        display flex
        flex-direction column
        > span
          width 100%
          &:first-child
            border 0
            border-bottom 1px solid rgba( 0 0 0 .1 )

        &:first-child
          border-right 1px solid rgba( 0 0 0 .1 )
  .stamp
    color blue
    font-size 4em
    position absolute
    height 100%
    width 100%
    label
      display block
      transform rotate(-36deg)
      font-weight bolder
      font-family 'arial black'
      letter-spacing 2px
      color rgba( 40 200 200 .2)
</style>
